function isPC() {
  return window.innerWidth > 768;
}

function showMV() {
  setTimeout(function(){
   $('.js-heading').addClass('is-active');
  },1000);
}

function waypoint() {
  $('.js-waypoint').waypoint(
    function(direction) {
      this.element.classList.add('is-active');
    },
    {
      offset: '70%',
    }
  );
}

$(function () {
  showMV();
  // waypoint();
  if (isPC()) {
    waypoint();
  }
  $(window).on('resize', function(){
    if (isPC()) {
      waypoint();
    }
  });
});
